export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/currentCode/currentCodequery?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
          data
        });
      },

  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/currentCode.js